import { get } from "lodash";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";
import { DATE_FORMAT, TEMPLATE_TYPES, TEMPLATES } from "utils/constants";
import {
  buildAcorisBeneficiaries,
  shouldShowAcorisBeneficiariesSection,
} from "screens/Private/Broker/Projects/Detail/Templates/Comparison/Acoris/utils/relatedPersonDisplay";
import cakeIcon from "../../../../../Assets/icons/cake.svg";
import diversityIcon from "../../../../../Assets/icons/diversity.svg";
import editSquareIcon from "../../../../../Assets/icons/edit_square.svg";
import faceIcon from "../../../../../Assets/icons/face.svg";
import Button from "../../../../Button";

function View({ contact, updateProjectStatus, onClose }) {
  const { t } = useTranslation(NAME_SPACES.PUBLIC.ACORIS);
  const translate = t("PROFILE_MODAL", { returnObjects: true });

  const firstname = get(contact, "user.firstname", "");
  const lastname = get(contact, "user.lastname", "");
  const displayName = `${firstname} ${lastname}`.trim();

  const birthDate = get(contact, "user.birthDate");
  const formattedBirthDate = birthDate
    ? moment(birthDate).format(DATE_FORMAT)
    : "";

  const relatedPersons = get(contact, "relatedPersons", []);
  const beneficiaries = buildAcorisBeneficiaries({
    relatedPersons,
    translate: translate?.BENEFICIARIES,
  });
  const showBeneficiariesSection = shouldShowAcorisBeneficiariesSection({
    beneficiaries,
  });

  const infoRows = [
    {
      key: "identity",
      icon: faceIcon,
      label: translate?.YOU_ARE,
      value: displayName,
      template: TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_ACORIS].ADHERENT_INFO,
      isBeforeLocked: true,
    },
    {
      key: "birthDate",
      icon: cakeIcon,
      label: translate?.BIRTH_DATE,
      value: formattedBirthDate,
      template:
        TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_ACORIS].ADHERENT_BIRTHDATE,
      isBeforeLocked: true,
    },
    ...(showBeneficiariesSection
      ? [
          {
            key: "beneficiaries",
            icon: diversityIcon,
            label: translate?.BENEFICIARIES_LABEL,
            value: beneficiaries,
            template:
              TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_ACORIS].RELATED_PERSONS,
            isBeforeLocked: false,
          },
        ]
      : []),
  ];

  const handleEdit = (template, isBeforeLocked = false) => {
    onClose();
    updateProjectStatus({ template, isBeforeLocked });
  };

  return (
    <div className="acoris-profile-modal__wrapper">
      <div className="acoris-profile-modal__body">
        <h2 className="acoris-profile-modal__title">{translate?.TITLE}</h2>

        <div className="acoris-profile-modal__info-list">
          {infoRows.map(
            ({ key, icon, label, value, template, isBeforeLocked }) => {
              const isBeneficiaries = key === "beneficiaries";
              const showRow =
                isBeneficiaries || (typeof value === "string" && value);

              if (!showRow) return null;

              return (
                <div className="acoris-profile-modal__info-item" key={key}>
                  <div className="acoris-profile-modal__info-main">
                    <img
                      src={icon}
                      alt=""
                      className="acoris-profile-modal__info-icon"
                    />
                    <div className="acoris-profile-modal__info-content">
                      <span className="acoris-profile-modal__info-label">
                        {label}
                      </span>
                      {isBeneficiaries ? (
                        <div className="acoris-profile-modal__info-value acoris-profile-modal__info-value--stack">
                          {value.map(({ name, label: roleLabel }) => (
                            <span key={`${name || "empty"}-${roleLabel}`}>
                              <strong>{name}</strong>
                              {roleLabel ? ` ${roleLabel}` : ""}
                            </span>
                          ))}
                        </div>
                      ) : (
                        <span className="acoris-profile-modal__info-value">
                          {value}
                        </span>
                      )}
                    </div>
                  </div>
                  <button
                    type="button"
                    className="acoris-profile-modal__info-edit"
                    onClick={() => handleEdit(template, isBeforeLocked)}
                    aria-label={translate?.EDIT}
                  >
                    <img src={editSquareIcon} alt="" />
                  </button>
                </div>
              );
            },
          )}
        </div>
      </div>

      <Button
        type="primary-outlined"
        alignment="center"
        className="acoris-profile-modal__close"
        onClick={onClose}
      >
        {translate?.CLOSE}
      </Button>
    </div>
  );
}

export default View;
